<template>
  <div>
    <b-table :id="id" :fields="localFields" :items="items" responsive small :filter="filter" :filter-included-fields="filterIncludedFields" :filter-function="filterFn" :empty-filtered-text="emptyFilteredText" @filtered="filtered" :stacked="stacked"
      :busy="loading" show-empty :empty-text="emptyText" :per-page="itemsPerPage" :current-page="currentPage">
      <template v-slot:table-busy>
        <loading-anim :active="loading"></loading-anim>
      </template>
      <!-- Iterate over all cell slots and insert in b-table-->
      <template v-for="(_, slotName) of $scopedSlots" v-slot:[slotName]="scope">
        <slot v-if="showTableCell(slotName)" :name="slotName" v-bind="scope" />
      </template>
    </b-table>
    <b-row>
      <b-col>
        <b-pagination pills v-model="currentPage" :total-rows="rows" :per-page="itemsPerPage" :aria-controls="id" hide-ellipsis first-number last-number>
          <template #prev-text><base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg" class="pagination-arrow" svgClasses="reverse" :color="arrowColor"/></template>
          <template #next-text><base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg" class="pagination-arrow" :color="arrowColor"/></template>
        </b-pagination>
      </b-col>
      <b-col v-if="showCaption">
         <span class="float-right text-info">{{ $t('table.pagination.label', paginationLabelData)}}</span>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BTable, BPagination, BRow, BCol } from 'bootstrap-vue'
import LoadingAnimVue from '../utils/LoadingAnim.vue'
import ArrowIcon from '@/components/base/icons/ArrowIcon.vue'

export default {
  name: 'paginated-table',
  components: {
    BTable,
    BRow,
    BCol,
    'loading-anim': LoadingAnimVue,
    BPagination,
    ArrowIcon
  },
  props: {
    fields: {
      type: Array,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    emptyText: {
      type: String,
      required: false,
      default () {
        return this.$t('table.no-results')
      }
    },
    showCaption: {
      type: Boolean,
      required: false,
      default () {
        return !this.$uiHelpers.isMobile
      }
    },
    emptyFilteredText: {
      type: String,
      default () {
        return this.$t('noMatchingElements')
      }
    },
    filter: [Array, Object, String, RegExp],
    filterIncludedFields: Array,
    filterFn: Function,
    stacked: [String, Boolean],
    itemsPerPage: {
      type: Number,
      required: false,
      default () {
        return this.stacked ? 3 : 5
      }
    }
  },
  created () {
    if (this.stacked) {
      this.localFields = this.fields.filter(item => !item.hiddenStacked)
    } else {
      this.localFields = this.fields
    }
  },
  data () {
    return {
      id: null,
      currentPage: 1,
      arrowColor: '#8A8A8A',
      filteredCount: 0,
      localFields: []
    }
  },
  computed: {
    rows () {
      return this.filter ? this.filteredCount : this.items.length
    },
    paginationLabelData () {
      const firstOfPage = this.currentPage === 1 ? 1 : ((this.currentPage - 1) * this.itemsPerPage)
      return {
        firstOfPage: firstOfPage,
        lastOfPage: firstOfPage === 1 ? (this.rows > this.itemsPerPage ? this.itemsPerPage : this.rows) : (firstOfPage + this.itemsPerPage),
        totalItems: this.rows
      }
    }
  },
  methods: {
    filtered (filteredItems) {
      this.filteredCount = filteredItems.length
    },
    showTableCell (slotName) {
      return (slotName.includes('cell') && !slotName.includes('actionsMobile')) || (slotName.includes('actionsMobile') && this.stacked)
    }
  },
  mounted () {
    this.id = `paginated-table-${this._uid.toString()}`
  }
}
</script>

<style lang="scss">
  $arrow-size: 17px;

  .pagination-arrow {
    width: $arrow-size;
    height: $arrow-size;
  }

  button:hover span svg g path {
    stroke: $white !important;
  }

  .showBtnTable{
    color: $blue;
    text-decoration: underline;
    cursor: pointer;
  }
  .hideBtnTable{
    color: $red;
    text-decoration: underline;
    cursor: pointer;
  }
  table {
    &[class*="stacked"]{
      tr{
        &.b-table-details{
          margin-top: 1rem;
              > td > div{
                  text-align: center;
              }
        }
      }
      td{
        padding: 0;
        &::before{
          font-size: 0.9rem;
        }
        > div{
          font-size: 0.9rem;
        }
        hr{
          margin-top: 1rem;
          margin-bottom: 1rem;
          width: 100%;
        }
      }
    }
    .table-actions{
        text-align: center;
        margin-top: 1rem;
        > div{
              width: 100% !important;
            > div {
              display: inline-block;
              margin-right: .5rem;
            }
        }
    }
    // @include media(mobile, tablets) {
    //   td{
    //     &[aria-colindex="1"]{
    //       max-width: 78px;
    //       overflow-wrap: break-word;
    //     }
    //   }
    //   th{
    //     &[aria-colindex="1"]{
    //       max-width: 78px;
    //       overflow-wrap: break-word;
    //     }
    //   }
    // }
  }
</style>


// WEBPACK FOOTER //
// src/components/base/PaginatedTable.vue